import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.27259 5.95657C2.954 1.6865 7.77634 -0.411033 12.0464 1.27037C16.3165 2.95178 18.414 7.77412 16.7326 12.0442C15.0512 16.3143 10.2289 18.4118 5.95879 16.7304C3.99253 15.9561 2.49259 14.5175 1.60067 12.7724",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.61523 4.8457V11.0765H13.846",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.833984 2.76953L0.8483 5.9671L4.04587 5.95279",
			stroke: "currentColor",
			strokeWidth: 1.3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgHistory;
